import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table table-sm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "align-middle text-center" }
const _hoisted_5 = { class: "align-middle text-center small" }
const _hoisted_6 = { class: "align-middle text-center" }
const _hoisted_7 = { class: "align-middle text-center text-nowrap py-1" }
const _hoisted_8 = { class: "d-flex justify-content-center align-items-center gap-1" }
const _hoisted_9 = { class: "align-middle" }
const _hoisted_10 = { class: "d-flex justify-content-center align-items-center gap-1 lh-1" }
const _hoisted_11 = { class: "align-middle small" }
const _hoisted_12 = { class: "align-middle text-nowrap" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between px-2 py-2" }
const _hoisted_15 = { class: "text-muted small" }
const _hoisted_16 = { "aria-label": "Paginación de transacciones" }
const _hoisted_17 = { class: "pagination pagination-sm mb-0" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "page-item disabled"
}
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "text-end text-muted small m-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "col-1 col-sm-1 align-middle text-center" }, "Tipo"),
          _createElementVNode("th", { class: "col-2 col-sm-3 col-lg-2 text-center" }, "Fecha"),
          _createElementVNode("th", { class: "col-1 col-sm-1 text-center" }, "Estatus"),
          _createElementVNode("th", { class: "col-1 col-sm-2 text-center" }, "Monto"),
          _createElementVNode("th", { class: "col-5 col-sm-6" }, "TX Hash")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (!_ctx.isTransactionsLoading && _ctx.transactions.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("td", {
                colspan: "5",
                class: "text-center"
              }, "No hay transacciones disponibles", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.isTransactionsLoading)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("td", {
                colspan: "5",
                class: "text-center"
              }, [
                _createElementVNode("i", { class: "fas fa-spinner fa-spin" }),
                _createTextVNode(" Actualizando...")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: transaction.id,
            class: "align-middle"
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.transactionDirectionClass(transaction.direction))
              }, null, 2)
            ]),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formatDateTimezone(transaction.date)), 1),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.transactionStatusClass(transaction.status))
              }, _toDisplayString(_ctx.transactionsStatusLabel(transaction.status)), 3)
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.transactionSymbolIconClass(transaction.direction))
                }, null, 2),
                _createElementVNode("span", _hoisted_9, _toDisplayString(transaction.amount) + " BTC", 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, "$ " + _toDisplayString(_ctx.formatUSD(transaction.amount)) + " USD", 1)
              ])
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("a", {
                href: 
              'https://blockchair.com/es/bitcoin/transaction/' +
              transaction.hash
            ,
                target: "_blank",
                class: "link-success"
              }, _toDisplayString(transaction.hash), 9, _hoisted_13)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, " Página " + _toDisplayString(_ctx.transactionsPage + 1) + " de " + _toDisplayString(_ctx.totalPages) + " · " + _toDisplayString(_ctx.transactionsTotalCount) + " registros ", 1),
      _createElementVNode("nav", _hoisted_16, [
        _createElementVNode("ul", _hoisted_17, [
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", { disabled: _ctx.transactionsPage === 0 || _ctx.isTransactionsLoading }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: _ctx.transactionsPage === 0 || _ctx.isTransactionsLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(0)))
            }, " « ", 8, _hoisted_18)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", { disabled: _ctx.transactionsPage === 0 || _ctx.isTransactionsLoading }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: _ctx.transactionsPage === 0 || _ctx.isTransactionsLoading,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevTransactionsPage && _ctx.prevTransactionsPage(...args)))
            }, " ‹ ", 8, _hoisted_19)
          ], 2),
          (_ctx.showLeftEllipsis)
            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "page-link" }, "…", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageWindow, (page) => {
            return (_openBlock(), _createElementBlock("li", {
              key: page,
              class: _normalizeClass(["page-item", { active: page === _ctx.transactionsPage }])
            }, [
              _createElementVNode("button", {
                class: "page-link",
                type: "button",
                disabled: _ctx.isTransactionsLoading,
                onClick: ($event: any) => (_ctx.goToPage(page))
              }, _toDisplayString(page + 1), 9, _hoisted_21)
            ], 2))
          }), 128)),
          (_ctx.showRightEllipsis)
            ? (_openBlock(), _createElementBlock("li", _hoisted_22, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "page-link" }, "…", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", {
            disabled:
              _ctx.transactionsPage >= _ctx.totalPages - 1 ||
              _ctx.isTransactionsLoading ||
              !_ctx.transactionsHasMore,
          }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: 
              _ctx.transactionsPage >= _ctx.totalPages - 1 ||
              _ctx.isTransactionsLoading ||
              !_ctx.transactionsHasMore
            ,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextTransactionsPage && _ctx.nextTransactionsPage(...args)))
            }, " › ", 8, _hoisted_23)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", {
            disabled:
              _ctx.transactionsPage >= _ctx.totalPages - 1 ||
              _ctx.isTransactionsLoading ||
              !_ctx.transactionsHasMore,
          }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: 
              _ctx.transactionsPage >= _ctx.totalPages - 1 ||
              _ctx.isTransactionsLoading ||
              !_ctx.transactionsHasMore
            ,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.totalPages - 1)))
            }, " » ", 8, _hoisted_24)
          ], 2)
        ])
      ])
    ]),
    (_ctx.formattedTransactionsUpdated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fw-bold" }, "Actualizado:", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.formattedTransactionsUpdated), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}